import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {select_tabTotals} from 'redux/totals/selectors'
import {BadgeCounter} from '@mdsol/onex-design'
import {tabNames, TabType} from 'router/settings'

interface TabTitleProps {
  tab: TabType,
  isActive?: boolean,
}

const TabTitle: FC<TabTitleProps> = ({tab, isActive = false}) => {
  const tabTotals = useSelector(select_tabTotals)
  const count = tabTotals[tab]

  const title = tabNames[tab]
  const badgeType = isActive ? 'information' : 'neutral'

  return (
    <div className='tabTitle'>
      {title}
      {count > 0 &&
        <BadgeCounter dataTestId='tab-badge-counter' variant={badgeType}>
          {count}
        </BadgeCounter>
      }
    </div>
  )
}

export default TabTitle
